import { render, staticRenderFns } from "./documentacionChangeNameModal.vue?vue&type=template&id=57e8c376&scoped=true&"
import script from "./documentacionChangeNameModal.vue?vue&type=script&lang=js&"
export * from "./documentacionChangeNameModal.vue?vue&type=script&lang=js&"
import style0 from "./documentacionChangeNameModal.vue?vue&type=style&index=0&id=57e8c376&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57e8c376",
  null
  
)

export default component.exports